import type { IconSvgObject } from './types';

const DashboardSpeed02Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "18", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 15V10", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 13C22 7.47715 17.5228 3 12 3C6.47715 3 2 7.47715 2 13", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default DashboardSpeed02Icon;
